<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import PageHeader from "@/components/page-header";
import treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
import BirimSecimi from "./birimsecimi.vue";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Hoşgeldiniz",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    treeselect,
    BirimSecimi,
  },
  data() {
    return {
      title: this.$t("userroles.Title"),
      items: [
        {
          text: this.$t("userroles.Title"),
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      PageToplu: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      //Kullanicilar: {},
      KullanicilarTable: {},
      Ouygulama: {},
      KullaniciRolleri: {},
      KullaniciAra: null,
      BirimAra: null,
      SeciliKullaniciYetkileri: {},
      SeciliYetkiKullaniciliari: {},
      Roles: [],
      KullanicilarArray: [],
      BirimArray: [],
      Tab: 1,
    };
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
  methods: {

    loadOptions({ action,  callback }) {      
      if (action === ASYNC_SEARCH) {
        
          simulateAsyncOperation(() => {
             this.options = this.KullanicilarArray;
          callback(null, this.options)
          
        })
       
      }
    },

    Get() {
      this.KullaniciRolleri = [];
      this.KullanicilarArray = [];

      this.ActionsGet({
        Service: "Ouygulama",
        Page: this.PageToplu,
      }).then((res) => {
        this.Ouygulama = res.Data;
        this.KullaniciRolleri = res.Data;
      });


      this.ActionsGet({
        Service: "obirim",
        Page: this.PageToplu,
      }).then((res) => {
        for (let i = 0; i < res.Data.length; i++) {
          this.BirimArray.push({
            id: res.Data[i].Id,
            label: res.Data[i].BirimAdi,
          });
        }
      });

 
    },

    kullanici_yukle( name ){

        if (name.length>2){
            this.KullanicilarArray=[];
            let Page = {
              PageNumber: "1",
              PageSize: "50",
            };
            let Filter="&name="+name
            this.ActionsFilterGet({
              Service: this.$config.API_ACCOUNT_URL + "Account/get-users",
              Page: Page,
              Filter:Filter
            }).then((res) => {
          
              for(let i=0; i<res.Data.length; i++){  
                this.KullanicilarArray.push({
                  id: res.Data[i].Id,
                label: res.Data[i].FirstName+" "+res.Data[i].LastName + "  /" + res.Data[i].Email,
              }); 
              }
            });
          



}

},

    YetkiKullaniciSorgu(BirimId) {
      this.ActionsFilterGet({
        Service: "ouserbirimyetki",
        Page: this.PageToplu,
        Filter: "&Birimid=" + BirimId+"&Uygulamaid=9626c24b-c3c5-4d70-a9c8-d040ddee9fa9",
      }).then((res) => {
        this.SeciliYetkiKullaniciliari = res.Data;
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader title="" :items="items" />
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="card-body">
            <h5 class="h4 card-title">
              {{ $t("userroles.page.yetkiislemleri") }}
            </h5>
            <p class="card-title-desc">
              {{
                $t(
                  "userroles.page.kullanicilaricinyetkinedirmeveyetkilistelemeekrani"
                )
              }}
            </p>

            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <b-tab active @click="Tab = 1">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("userroles.page.kullaniciyetkilendirme")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.kullaniciara") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkilendirmekistediginizkullaniciyiseciniz"
                      )
                    }} 
                  </p>
                  <div class="col-lg-12">
                    <treeselect
                      :multiple="false"
                      :clear-search-on-select="true"
                      :load-options="loadOptions"
                      :cacheOptions="false"
                      @search-change="kullanici_yukle($event)"
                      :async="true"
                      placeholder="Seçiniz..."
                      name="KullaniciAra"
                      v-model="KullaniciAra"
                    />
                  </div>

              
                </div>
              </b-tab>

              <b-tab @click="Tab = 2">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("userroles.page.birimlistele")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.birimler") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.birimebaglikullanicilarigormekcinsecimyapin"
                      )
                    }}
                  </p>
                  <div class="col-lg-12">
                    <treeselect
                      :multiple="false"
                      :options="BirimArray"
                      placeholder="Seçiniz..."
                      v-model="BirimAra"
                      @select="YetkiKullaniciSorgu($event.id)"
                    />
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="KullaniciAra && Tab == 1">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ this.$t("userroles.page.kullaniciyetkilendirmeekrani") }}
          </h5>
          <p class="card-title-desc">
            {{ this.$t("userroles.page.ekampusicin") }}
            {{ this.$t("userroles.page.yetkilendirmeekrani") }}
          </p>

          <div class="row">
            <div
              class="col-lg-12"
             
            >
              <div class="mt-4 mt-lg-0 mb-3" style="height:300px">
                <BirimSecimi
                  :Userid="KullaniciAra"
                  title="Strateji Bilgi Sistemi"
                  Uygulamaid="9626c24b-c3c5-4d70-a9c8-d040ddee9fa9"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="BirimAra && Tab == 2">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </h5>
          <p class="card-title-desc">
            {{ $t("userroles.page.listelenenyetki") }}
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </p>

          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t("userroles.table.FirstName") }}</th>
                  <th scope="col">{{ $t("userroles.table.LastName") }}</th>
                  <th scope="col">{{ $t("userroles.table.Email") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(Kullanici, index) in SeciliYetkiKullaniciliari"
                  :key="index"
                >
                  <td>{{ Kullanici.Adi }}</td>
                  <td>{{ Kullanici.Soyadi }}</td>
                  <td>{{ Kullanici.Mail }}</td>
                </tr>
              </tbody>
            </table>
            <b-pagination
              class="pagination pagination-rounded justify-content-end mb-2"
              v-model="DefaultPage"
              :total-rows="Page.PageDataSize"
              :per-page="Page.PageSize"
              aria-controls="my-table"
              @input="ChangePage(DefaultPage)"
            >
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
